export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const RESET_ORGANIZATION = 'RESET_ORGANIZATION';
